import { useSidebar, CONTEXT_DEPTH } from '_/contexts/LayoutContext';
import { useSuperAdminSidebarItems } from '_/hooks/useSuperAdminSidebarItems';
import React, { ReactNode, useEffect } from 'react';

interface MainSectionProps {
  children: ReactNode;
}

/**
 * MainSection - Wrapper for main/admin level pages
 * Manages sidebar items for admin pages (organizations, users, extraction cells, etc.) via context depth system
 */
function MainSection({ children }: MainSectionProps) {
  const sidebarItems = useSuperAdminSidebarItems();
  const { setSidebarItems, registerContext, unregisterContext } = useSidebar();

  useEffect(() => {
    // Register this context level
    registerContext(CONTEXT_DEPTH.MAIN);

    return () => {
      // Unregister on unmount
      unregisterContext(CONTEXT_DEPTH.MAIN);
    };
  }, [registerContext, unregisterContext]);

  useEffect(() => {
    // Set sidebar items whenever they change
    if (sidebarItems.length > 0) {
      setSidebarItems(sidebarItems, CONTEXT_DEPTH.MAIN);
    }
  }, [setSidebarItems, sidebarItems]);

  return <>{children}</>;
}

export default MainSection;
